import { cn } from '@/lib/utils';

export const Section = ({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) => {
  return (
    <div
      className={cn(
        'rounded-lg border border-gray-300 p-4 dark:border-gray-600',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
